import { styled } from "@mui/system"
import { Box, Typography } from "@mui/material"

export const Display = styled(Box)({
  display: "flex",
  flexDirection: "row",
  gap: "64px",
  padding: "32px",
})

export const CounterLabel = styled(Typography)({
  color: "var(--brand-text-sec)",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",
})

export const CounterValue = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "warning",
})((props: { warning: boolean }) => ({
  color: props.warning ? "var(--cherry)" : "var(--brand-text-default)", 
  fontSize: "45px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "52px",
}))

export const Separator = styled(Box)({
  width: "1px",
  height: "72px",
  borderRadius: "0px",
  background: "var(--grey-grey-03)",
})

export const CounterElementWrapper = styled(Box)({
  minWidth: "fit-content",
})
